import { render, staticRenderFns } from "./payments-charges.vue?vue&type=template&id=1eca9e58&"
import script from "./payments-charges.vue?vue&type=script&lang=js&"
export * from "./payments-charges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports